import { queryOptions } from '@tanstack/react-query'
import { minutesToMs } from 'utils/general'

import { getRatingChips } from '../service/combinedapi/reviews'

export const reviewQueries = {
  ratingChips: () =>
    queryOptions({
      queryKey: ['ratingChips'],
      queryFn: () => getRatingChips(),
      staleTime: minutesToMs(30),
    }),
}
